/**
 * Author : wang885298.
 * Date   : 2018/7/20.
 * File   : util.
 */
import request from './request'

/***
 * 节流函数 在wait间隔时间内不再进行任何调用时，触发一次最后的调用（如:wait设置为300ms，一直点击，该函数一直不执行，只有在间隔了300ms不做任何点击后，才执行刚才的最后一次点击）
 * @param func 执行函数
 * @param wait 等待时间
 * @param {Boolean} immediate 是否立即执行
 * @return {Function}
 */
function throttle (func, wait, immediate) {
  var timeout
  return function () {
    let context = this
    let args = arguments
    let later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    let callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

/**
 * 判断对象是否为空对象
 * @param e 判断对象
 * @returns {boolean}
 */
function isEmptyObject (e) {
  if (!e) return true
  // vue 框架给数组添加了一个$remove的方法，所以对数组单独判断
  if (e instanceof Array) {
    if (e.length > 0) {
      return false
    } else {
      return true
    }
  }
  for (var t in e) {
    return false
  }
  return true
}

/**
 * 获取相应字典明细（获取证件类型，性别列表,婚姻状态,车辆使用性质,车辆证件类型）
 * @param fuJiMxBh
 * @param zhiDianBh:字典编号
 * @author wanghongling
 */
function ziDianMXListGet ({fuJiMxBh, zhiDianBh}) {
  let params = {
    zhiDianBh: zhiDianBh
  }
  if (fuJiMxBh) {
    params.fuJiMxBh = fuJiMxBh
  }
  return request.ziDianMXListGet(params).then(res => res).catch(e => {
    console.error(e)
  })
}
/**
 * @Description:formateNumber小于10的数字补0
 * @author wanghongling
 * @createDate 2020/2/28
*/
var formateNumber = num => {
  num = num < 10 ? `0${num}` : num
  return num
}

var formatTime = ({date}) => {
  var dateTime = {
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear(),
    sec: date.getSeconds(),
    min: date.getMinutes(),
    hour: date.getHours()
  }
  var formatNumbers = ['month', 'day', 'sec', 'min', 'hour']
  formatNumbers.forEach(v => {
    dateTime[v] = formateNumber(dateTime[v])
  })
  return {
    date: `${dateTime.year}-${dateTime.month}-${dateTime.day}`,
    time: `${dateTime.hour}:${dateTime.min}:${dateTime.sec}`,
    dateTime: `${dateTime.year}-${dateTime.month}-${dateTime.day} ${dateTime.hour}:${dateTime.min}:${dateTime.sec}`
  }
}
// 获取当前时间，格式YYYY-MM-DD
function getNowFormatDate() {
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  return `${year}-${month}-${strDate}`
}

function merge (target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    let source = arguments[i] || {}
    for (let prop in source) {
      if (source.hasOwnProperty(prop)) {
        let value = source[prop]
        if (value !== undefined) {
          target[prop] = value
        }
      }
    }
  }
  return target
}

export {
  throttle,
  isEmptyObject,
  ziDianMXListGet,
  formateNumber,
  formatTime,
  getNowFormatDate,
  merge
}



// WEBPACK FOOTER //
// ./src/util.js